// Moisture / dry-mass math — spec §9.2.
import { toDecimal, formatQty, formatPct } from './internal/decimal-utils.js';
/**
 * dry_kg = wet_kg × (1 − mc/100).
 * `mcPct === null` means the product is not moisture-tracked (no moisture concept
 * applies), so dry mass equals wet mass — there is nothing to subtract.
 */
export function dryKg(wetKg, mcPct) {
    const wet = toDecimal(wetKg);
    if (mcPct === null) {
        return formatQty(wet);
    }
    const mc = toDecimal(mcPct);
    return formatQty(wet.times(toDecimal(1).minus(mc.div(100))));
}
/**
 * Derives a pool's average moisture % from its accumulated wet/dry kg, per
 * `avg_mc = (1 - dry/wet) × 100` (spec §9.2 — never stored, always derived).
 * A pool with no wet mass has no meaningful moisture reading; returns "0.00".
 */
export function poolAvgMc(wetKg, dryKg) {
    const wet = toDecimal(wetKg);
    if (wet.lte(0)) {
        return '0.00';
    }
    const dry = toDecimal(dryKg);
    return formatPct(toDecimal(1).minus(dry.div(wet)).times(100));
}
//# sourceMappingURL=moisture.js.map